var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00BFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9837 13.0218C6.75789 13.0218 4.9472 11.2223 4.9472 9.01116C4.9472 6.79941 6.75845 5.00054 8.9837 5.00054C11.2095 5.00054 13.0202 6.79941 13.0202 9.01116C13.0202 11.2223 11.2095 13.0218 8.9837 13.0218ZM8.9837 5.78579C7.19439 5.78579 5.73808 7.23254 5.73808 9.01116C5.73808 10.7892 7.19439 12.236 8.9837 12.236C10.7736 12.236 12.2293 10.7892 12.2293 9.01116C12.2293 7.23254 10.7736 5.78579 8.9837 5.78579ZM11.8103 4.42735C10.9587 3.90884 9.98069 3.63518 8.9837 3.63647C8.06599 3.63609 7.1631 3.86791 6.35908 4.31035L5.97433 3.6241C6.89605 3.11623 7.93133 2.84996 8.9837 2.8501C10.1312 2.8501 11.2517 3.16397 12.2243 3.75797L11.8103 4.42735ZM12.9887 13.7142L12.4774 13.114C13.077 12.6116 13.5592 11.9839 13.8901 11.275C14.221 10.5662 14.3925 9.79344 14.3927 9.01116H15.1836C15.1836 10.8258 14.3837 12.5397 12.9887 13.7137V13.7142ZM8.9837 15.1711C7.54539 15.1711 6.14364 14.6705 5.0372 13.762L5.5412 13.1568C6.5125 13.9514 7.72876 14.3857 8.9837 14.3858C9.8612 14.3858 10.6982 14.1833 11.4711 13.7851L11.835 14.4826C10.9527 14.9353 9.97536 15.171 8.9837 15.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.2594 7.55151C14.0526 6.80978 13.6889 6.12112 13.1929 5.53213L13.6991 5.11251C14.2552 5.77284 14.6628 6.54496 14.8944 7.37657L14.2594 7.55151ZM3.85876 12.3614C3.19953 11.3686 2.84863 10.203 2.85019 9.0112C2.85019 7.34507 3.51394 5.7892 4.71938 4.62988L5.17726 5.1007C4.64808 5.60497 4.22723 6.2118 3.94038 6.88414C3.65354 7.55648 3.50672 8.28023 3.50888 9.0112C3.50888 10.0794 3.82051 11.1133 4.40888 12.0014L3.85876 12.3614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAion);
export default __webpack_public_path__ + "static/media/aion.728a72a3b9a5dcac7dbfe519b78fc6a4.svg";
export { ForwardRef as ReactComponent };